import { inject, Injectable, OnDestroy } from '@angular/core';
import { ResinApiClient } from '../api-clients/resin.client';
import { ResinSource } from '../enums';
import { BehaviorSubject, map, shareReplay, switchMap } from 'rxjs';
import { Resin } from '../models';

const orderedByValue: string = 'SprintRay';

function sortResins(resins: Resin[]) {
    return resins.sort((a, b) => {
        const firstContainsOrderedByValue =
            a.manufacturer && a.manufacturer.toLowerCase().includes(orderedByValue.toLowerCase());
        const secondContainsOrderedByValue =
            b.manufacturer && b.manufacturer.toLowerCase().includes(orderedByValue.toLowerCase());

        if (firstContainsOrderedByValue && !secondContainsOrderedByValue) {
            return -1;
        } else if (!firstContainsOrderedByValue && secondContainsOrderedByValue) {
            return 1;
        }

        return a.name.localeCompare(b.name);
    });
}

@Injectable({
    providedIn: 'root',
})
export class ResinStore implements OnDestroy {
    private readonly _apiClient = inject(ResinApiClient);
    private refreshSource$ = new BehaviorSubject(Date.now());

    readonly dsResinRaw$ = this.refreshSource$.pipe(
        switchMap(() => this._apiClient.listAllResins(ResinSource.ds)),
        shareReplay(1)
    );
    readonly rwcResinRaw$ = this.refreshSource$.pipe(
        switchMap(() => this._apiClient.listAllResins(ResinSource.rwc)),
        shareReplay(1)
    );
    readonly dsResinOptions$ = this.dsResinRaw$.pipe(
        map(v => v.data),
        map(sortResins)
    );
    readonly rwcResinOptions$ = this.rwcResinRaw$.pipe(
        map(v => v.data),
        map(sortResins)
    );

    ngOnDestroy() {
        this.refreshSource$.complete();
    }

    refresh() {
        this.refreshSource$.next(Date.now());
    }
}
